import { TableEmptyState } from '@practium/ui';
import type { Property } from '../../../types';
import styles from '../PropertiesTable.module.css';

interface PropertiesTableProps {
	properties: Property[];
	onRowClick?: (id: string) => void;
}

export const PropertiesTable = ({ properties, onRowClick }: PropertiesTableProps) => {
	if (properties.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma propriedade encontrada"
				subtitle="Adicione uma propriedade para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Estado</th>
						<th>Cidade</th>
						<th>Qtd. Áreas</th>
						<th>Qtd. Setores</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{properties.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.state}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.address.city}</span>
							</td>
							<td>
								<span className={styles.cellNumber}>{item.totalAreas}</span>
							</td>
							<td>
								<span className={styles.cellNumber}>{item.totalSectors}</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
